export function copyToClipboard(value: string) {
    if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
        window.navigator.clipboard.writeText(value);
        return true;
    } else if (document.queryCommandSupported('copy') === true) {
        const el = document.createElement('textarea');
        el.style.top = '0';
        el.style.left = '0';
        el.style.width = '2em';
        el.style.height = '2em';
        el.style.border = 'none';
        el.style.padding = '0';
        el.style.outline = 'none';
        el.style.position = 'fixed';
        el.style.boxShadow = 'none';
        el.style.background = 'transparent';
        document.body.appendChild(el);
        el.value = value;
        el.focus();
        el.select();
        const copyResult = document.execCommand('copy');
        document.body.removeChild(el);
        return copyResult;
    }
    return false;
}

export function downloadFile(fileName: string, fileContent: any, mimeType: string) {
    if (mimeType) {
        const el = document.createElement('a');
        el.setAttribute('href', `data:${mimeType};charset=utf-8,` + encodeURIComponent(fileContent));
        el.setAttribute('download', fileName);
        el.style.display = 'none';
        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
    } else {
        downloadFileOfAnyMimeType(fileName, fileContent);
    }
}

export function base64toBlob(base64Data, contentType): Blob {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

function downloadFileOfAnyMimeType(fileName: string, fileContent: any) {
    const el = document.createElement('a');
    el.href = window.URL.createObjectURL(fileContent);
    el.download = fileName;
    el.style.display = 'none';
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
}

/**
 * Xreate File from fileData
 * @param fileData EX: base64string
 * @param fileName Ex: 'MyName.png' )
 * @param fileType Ex: 'image/png')
 */
export function createFile(fileData: string, fileName:string, fileType: string): File{
    const binaryString = atob(fileData);
    const uint8Array = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([uint8Array]);
      return new File([blob], fileName, {type: fileType});
}
